import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-slides', 'titleNav', 'Slides navigation');
Labels.set('ui-slides', 'prev', 'Previous');
Labels.set('ui-slides', 'next', 'Next');
Labels.set('ui-slides', 'slide', 'Slide');
